import Modal from '@/components/modules/Modal';
import CreatePosition from '@/components/views/CreatePosition';
import type { CreatePositionModalProps } from '@/presentation/context/modal/ModalContext';

const CreatePositionModal = (props: CreatePositionModalProps) => {
  return (
    <Modal size="3xl" clickOffToClose={false} offset="">
      <CreatePosition {...props} withinModal={true} />
    </Modal>
  );
};

export default CreatePositionModal;
